import Progress from './src/progress';

module.exports = Progress;


// WEBPACK FOOTER //
// ./src/components/progress/index.js